<div class="container py-3 marketplace">
  <div class="d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
    <div></div>
    <div class="btn-group" role="group">
      <button class="btn btn-sm btn-outline-primary" [class.active]="activeTab==='browse'" (click)="setTab('browse')">Browse</button>
      <button class="btn btn-sm btn-outline-primary" [class.active]="activeTab==='myBids'" (click)="setTab('myBids')">My Bids</button>
      <button class="btn btn-sm btn-outline-primary" [class.active]="activeTab==='myListings'" (click)="setTab('myListings')">My Listings</button>
    </div>
  </div>

  @if (activeTab !== 'myBids') {
    <div class="card mb-3">
      <div class="card-body d-flex flex-wrap align-items-end gap-3">
        <div class="flex-grow-1">
          <label class="form-label small m-0">Search</label>
          <input type="text" class="form-control" [(ngModel)]="filters.query" placeholder="Search listings..." />
        </div>
        <div>
          <label class="form-label small m-0">Category</label>
          <select class="form-select" [(ngModel)]="filters.category">
            <option value="">All</option>
            @for (c of categories; track c) {
              <option [value]="c">{{ c }}</option>
            }
          </select>
        </div>
        <div class="form-check mt-4">
          <input class="form-check-input" type="checkbox" id="remoteOnly" [(ngModel)]="filters.remoteOnly" />
          <label for="remoteOnly" class="form-check-label">Remote only</label>
        </div>
        <div>
          <label class="form-label small m-0">Budget min</label>
          <input type="number" class="form-control" [(ngModel)]="filters.budgetMin" />
        </div>
        <div>
          <label class="form-label small m-0">Budget max</label>
          <input type="number" class="form-control" [(ngModel)]="filters.budgetMax" />
        </div>
        <div class="ms-auto">
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="openCreateListing()">
            <i class="bi bi-plus-lg me-1"></i> Create listing
          </button>
        </div>
      </div>
    </div>
  }

  @if (loading) {
    <div class="text-muted small">Loading listings…</div>
  }

  @if (!loading && activeTab !== 'myBids' && displayedProjects.length === 0) {
    <div class="alert alert-info">
      No marketplace listings found yet.
    </div>
  }

  @if (activeTab === 'myListings') {
    @if (showListingForm) {
      <div class="card mb-3">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="fw-500">{{ editingListingId ? 'Edit listing' : 'Create listing' }}</div>
            <div class="d-flex gap-2">
              <button class="btn btn-sm btn-outline-secondary" type="button" (click)="cancelListingForm()">Cancel</button>
              <button class="btn btn-sm btn-primary" type="button" (click)="submitListing()" [disabled]="savingListing">
                @if (!savingListing) { Save } @else { Saving… }
              </button>
            </div>
          </div>

          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Title</label>
              <input class="form-control" [(ngModel)]="listingDraft.title" placeholder="e.g. Build a customer portal" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Category</label>
              <select class="form-select" [(ngModel)]="listingDraft.category">
                <option value="" disabled>Select</option>
                @for (c of categories; track c) {
                  <option [value]="c">{{ c }}</option>
                }
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">Budget</label>
              <input type="number" class="form-control" [(ngModel)]="listingDraft.budget" />
            </div>
            <div class="col-md-4">
              <label class="form-label">Timeframe (weeks)</label>
              <input type="number" class="form-control" [(ngModel)]="listingDraft.timeframeWeeks" />
            </div>
            <div class="col-md-4 d-flex align-items-end">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="remoteListing" [(ngModel)]="listingDraft.remote" />
                <label class="form-check-label" for="remoteListing">Remote</label>
              </div>
            </div>
            <div class="col-12">
              <label class="form-label">Tags (comma separated)</label>
              <input class="form-control" [(ngModel)]="listingDraft.tagsText" placeholder="Angular, SCSS, Bootstrap" />
            </div>
            <div class="col-12">
              <label class="form-label">Description</label>
              <textarea class="form-control" rows="4" [(ngModel)]="listingDraft.description"></textarea>
            </div>
            <div class="col-md-6">
              <label class="form-label">Requirements (one per line)</label>
              <textarea class="form-control" rows="4" [(ngModel)]="listingDraft.requirementsText"></textarea>
            </div>
            <div class="col-md-6">
              <label class="form-label">Deliverables (one per line)</label>
              <textarea class="form-control" rows="4" [(ngModel)]="listingDraft.deliverablesText"></textarea>
            </div>
            <div class="col-md-6">
              <label class="form-label">Tech stack (comma separated)</label>
              <input class="form-control" [(ngModel)]="listingDraft.techStackText" placeholder="Angular, Node, Postgres" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Hours/week</label>
              <input type="number" class="form-control" [(ngModel)]="listingDraft.commitmentHoursPerWeek" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Start date</label>
              <input type="date" class="form-control" [(ngModel)]="listingDraft.startDate" />
            </div>
            <div class="col-12">
              <label class="form-label">Timezone (optional)</label>
              <input class="form-control" [(ngModel)]="listingDraft.timezone" placeholder="e.g. UTC+2" />
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="d-flex justify-content-end mb-3">
        <button class="btn btn-sm btn-primary" type="button" (click)="openCreateListing()">
          <i class="bi bi-plus-lg me-1"></i> Create listing
        </button>
      </div>
    }
  }

  @if (activeTab === 'myBids') {
    <div class="card">
      <div class="card-body">
        <div class="fw-500 mb-2">My bids</div>
        @if (myBidsView.length === 0) {
          <div class="text-muted small">No bids yet.</div>
        } @else {
          <div class="table-responsive">
            <table class="table table-sm align-middle mb-0">
              <thead>
                <tr>
                  <th>Listing</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (row of myBidsView; track (row.bid.id || row.bid.listingId)) {
                  <tr>
                    <td>
                      <div class="fw-500">{{ row.listing?.title || row.bid.listingId }}</div>
                      <div class="text-muted small">{{ row.listing?.organizationName || '—' }}</div>
                    </td>
                    <td>${{ row.bid.amount }}</td>
                    <td><span class="badge bg-secondary">{{ row.bid.status }}</span></td>
                    <td class="text-end">
                      <button class="btn btn-sm btn-outline-danger" type="button" (click)="withdrawBid(row.bid)">Withdraw</button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
  }

  @if (activeTab !== 'myBids') {
    <div class="row g-3">
      @for (p of displayedProjects; track (p.id || p.title)) {
        <div class="col-12 col-md-6 col-lg-4">
          <div class="card h-100">
            <div class="card-body d-flex flex-column">
              <div class="d-flex align-items-start justify-content-between mb-2">
                <div>
                  <div class="fw-semibold">{{ p.title }}</div>
                  <div class="text-muted small">{{ p.organizationName || '—' }} • {{ p.category }} • {{ p.remote ? 'Remote' : 'Onsite' }}</div>
                </div>
                <button class="btn btn-sm btn-outline-secondary" type="button" (click)="toggleSave(p.id)" aria-label="Save">
                  <i class="bi bi-bookmark"></i>
                </button>
              </div>
              <div class="small mb-2">Budget: ${{ p.budget }} • Timeframe: {{ p.timeframeWeeks }} weeks</div>
              <div class="mb-2">
                @for (t of p.tags; track t) {
                  <span class="badge bg-secondary me-1">{{ t }}</span>
                }
              </div>
              <div class="text-truncate-3 mb-3">{{ p.description }}</div>

              @if (activeTab === 'browse') {
                @if (biddingListingId === p.id) {
                  <div class="border rounded p-2 mb-2" style="border-color: var(--color-border)">
                    <div class="small fw-500 mb-1">Submit bid</div>
                    <div class="mb-2">
                      <label class="form-label small m-0">Amount</label>
                      <input type="number" class="form-control form-control-sm" [(ngModel)]="bidAmount" />
                    </div>
                    <div class="mb-2">
                      <label class="form-label small m-0">Message (optional)</label>
                      <input class="form-control form-control-sm" [(ngModel)]="bidMessage" placeholder="Short note…" />
                    </div>
                    <div class="d-flex gap-2">
                      <button class="btn btn-sm btn-primary" type="button" (click)="submitBid(p)" [disabled]="savingBid">
                        @if (!savingBid) { Submit } @else { Saving… }
                      </button>
                      <button class="btn btn-sm btn-outline-secondary" type="button" (click)="cancelBid()">Cancel</button>
                    </div>
                  </div>
                }
              }

              <div class="d-flex justify-content-between mt-auto small text-muted">
                <span>Status: {{ p.status }}</span>
              </div>

              <div class="d-flex gap-2 mt-3">
                <button class="btn btn-sm btn-outline-primary" type="button" (click)="viewProject(p.id)"><i class="bi bi-eye me-1"></i> View</button>
                @if (activeTab === 'browse') {
                  <button class="btn btn-sm btn-primary" type="button" (click)="startBid(p.id)"><i class="bi bi-cash-coin me-1"></i> Bid</button>
                }
                @if (activeTab === 'myListings') {
                  <button class="btn btn-sm btn-outline-primary" type="button" (click)="editListing(p)"><i class="bi bi-pencil me-1"></i> Edit</button>
                  <div class="btn-group ms-auto">
                    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="setListingStatus(p, 'open')">Open</button>
                    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="setListingStatus(p, 'paused')">Pause</button>
                    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="setListingStatus(p, 'closed')">Close</button>
                  </div>
                  <button class="btn btn-sm btn-outline-danger" type="button" (click)="deleteListing(p)">Delete</button>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
